import { Box } from '@mui/material'
import { forwardRef } from 'react'

import type { RefObject } from 'react'

type Props = {
  handleScroll: () => void
  widthRef: RefObject<HTMLDivElement | null>
}

export const TopScrollbar = forwardRef<HTMLDivElement, Props>(({ handleScroll, widthRef }, ref) => (
  <Box
    onScroll={handleScroll}
    ref={ref}
    sx={{ overflowX: 'auto' }}
  >
    <Box
      ref={widthRef}
      sx={{
        display: 'block',
        minHeight: '1px',
      }}
    />
  </Box>
))

TopScrollbar.displayName = 'TopScrollbar'
